import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AppCard from '@crema/core/AppCard';
import AppScrollbar from '@crema/core/AppScrollbar';
import { ArrowBack, Info, Person } from '@mui/icons-material';
import AppConfirmDialog from '@crema/core/AppConfirmDialog';
import ModalSkComment from '../ModalSkComment/index';
import {
    Avatar,
    Box,
    Breadcrumbs,
    Chip,
    Divider,
    FormControl,
    Grid,
    IconButton,
    MenuItem,
    Select,
    Stack,
    Tooltip,
    Typography,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ButtonContained, ButtonOutlined } from 'shared/components/Button';
import { COLORS, stringAvatar } from 'shared/constants/AppEnums';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MediaViewer from 'shared/components/MediaViewer';
import { getFileSize } from '@crema/utility/Utils';
import DialogSignDetail from '../../Dialog/DialogSignDetail';
import { useDispatch } from 'react-redux';
import {
    onApproveDocumentDigisign,
    onDeleteAttachmentDigisign,
    onGetDetailDigisign,
    onPutDocumentSkReject,
    onPutDocumentSkReturn,
    onPutDocumentSkRevision,
    onReleaseDigiSign,
    onUpdateSignDigisign,
    onChangeFilter
} from 'redux/actions/DigitalSign';
import { useSelector } from 'react-redux';
import moment from 'moment';
import AppInfoView from '@crema/core/AppInfoView';
import LogHistory from '../../Components/LogHistory';
import { useAuthUser, useAuthMethod } from '@crema/utility/AuthHooks';
import DialogKonfirmasi from 'shared/components/DialogKonfirmasi'

// Tertiary color, same as the "Tolak" button on Dokumen Lain
const tolakButtonSx = {
    background: '#d2b48c !important',
    '&:hover': { background: '#a58b67 !important' },
};

const Detail = ({ setRefresh }) => {
    const dispatch = useDispatch();
    const { user } = useAuthUser();
    const navigation = useNavigate();
    const { id, type } = useParams();
    const { pathname, search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const { setUser } = useAuthMethod()

    const { profileMe } = useSelector((state) => state.profile);
    const { detail, filter } = useSelector((state) => state.digiSign);

    const [logs, setLogs] = useState([]);
    const [index, setIndex] = useState(-1);
    const [comment, setComment] = useState('');
    const [commentType, setCommentType] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [releaseRole, setReleaseRole] = useState(false);
    const [isProcessed, setIsProcessed] = useState(false);
    const [modalComment, setModalComment] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState(null);
    const [monitoringRole, setMonitoringRole] = useState(false);
    const [modalConfReturn, setModalConfReturn] = useState(false);
    const [modalConfReject, setModalConfReject] = useState(false);
    const [modalConfApprove, setModalConfApprove] = useState(false);
    const [modalConfRelease, setModalConfRelease] = useState(false);
    const [modalConfRevision, setModalConfRevision] = useState(false);
    const [modalConfBypass, setModalConfBypass] = useState(false);
    const [stateDialog, setStateDialog] = useState({
        passphrase: '',
        komentar: '',
        isBypass: true,
    });
    const hasBypassRole = user?.roles_coofis?.some(
        (item) => item.state === 'BYPASS_PASSPHRASE',
    );
    const [error, setError] = useState({
        passphrase: false,
        komentar: false,
    });

    const approveCheck = (length, sequence, index) => {
        if (sequence <= index) {
            return (
                <>
                    <Stack
                        alignItems={'center'}
                        justifyContent={'center'}
                        sx={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '10px',
                            backgroundColor: COLORS.primary,
                        }}
                    >
                        <CloseIcon sx={{ fontSize: '10px', color: '#fff' }} />
                    </Stack>
                    <Chip
                        label={
                            length == index + 1 ? 'Belum Ditandatangan' : 'Belum Disetujui'
                        }
                        style={{
                            backgroundColor: COLORS.secondary,
                        }}
                        sx={{
                            color: COLORS.primary,
                            // marginRight: '10px',
                            // marginBottom: '10px'
                        }}
                        size='small'
                    />
                </>
            );
        } else if (sequence > index) {
            return (
                <>
                    <Stack
                        alignItems={'center'}
                        justifyContent={'center'}
                        sx={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '10px',
                            backgroundColor: '#11C15B',
                        }}
                    >
                        <CheckIcon sx={{ fontSize: '10px', color: '#fff' }} />
                    </Stack>
                    <Chip
                        label={length == index + 1 ? 'Ditandangani' : 'Disetujui'}
                        style={{
                            backgroundColor: '#D9F5E5',
                        }}
                        sx={{
                            color: '#11C15B',
                            // marginRight: '10px',
                            // marginBottom: '10px'
                        }}
                        size='small'
                    />
                </>
            );
        }
    };

    const handleChangeDialog = (name, value) => {
        setStateDialog({
            ...stateDialog,
            [name]: value
        })
    }

    const getFileExtension = (fileName) => {
        return fileName.split('.').pop().toLowerCase();
    };

    const handleShowAttachment = (index) => {
        setIndex(index);
    };

    const onCloseShowAttachment = () => {
        setIndex(-1);
    };

    const handleReturn = () => {
        let data = {
            id_documents: [id],
            comment: comment,
        };
        setIsProcessed(true);
        dispatch(onPutDocumentSkReturn(data));
        setTimeout(() => {
            setComment('');
            setCommentType(null);
            navigation(`/apps/dokumen-sk`);
        }, 3000);
    };

    // Default (no args) = bypass sign with saved passphrase
    const handleSign = (passphrase = '', isBypass = true) => {
        let data = {
            passphrase: passphrase,
            id_documents: [detail.id],
            sign_date: moment().format('DD MMMM YYYY'),
            is_bypass: isBypass ? 'true' : 'false',
        };
        setIsProcessed(true);
        dispatch(onApproveDocumentDigisign(
            data,
            () => {
                setUser({
                    ...user,
                    is_bypass: isBypass
                })
                navigation(`/apps/dokumen-sk?type=${type}`);
            },
            () => {
                setIsProcessed(false);
                setUser({
                    ...user,
                    is_bypass: false
                })
            }
        ));
    };

    const handleRevision = () => {
        let data = {
            id_documents: [id],
            comment: comment,
        };
        setIsProcessed(true);
        dispatch(onPutDocumentSkRevision(data));
        setTimeout(() => {
            setComment('');
            setCommentType(null);
            navigation(`/apps/dokumen-sk`);
        }, 3000);
    };

    const handleReject = () => {
        let data = {
            id_documents: [id],
            comment: comment,
        };
        setIsProcessed(true);
        dispatch(onPutDocumentSkReject(data));
        setTimeout(() => {
            setComment('');
            setCommentType(null);
            navigation(`/apps/dokumen-sk?type=${type}`);
        }, 3000);
    };

    const handleApprove = () => {
        const isLastApprover = detail.approvers[detail.approvers.length - 2].sequence === detail.sequence;
        let data = {
            passphrase: 'approve',
            id_documents: [detail.id],
            sign_date: moment().format('DD MMMM YYYY'),
            app: 'Dokumen SK',
            base_url: isLastApprover ? `/apps/dokumen-sk/detail/${type}/$id?filter=sk-need-sign` : `/apps/dokumen-sk/detail/${type}/$id?filter=sk-need-approval`,
            message: isLastApprover ? 'Dokumen perlu ditandatangani' : 'Dokumen perlu disetujui',
        };
        setIsProcessed(true);
        dispatch(onApproveDocumentDigisign(data));
        setTimeout(() => {
            navigation(`/apps/dokumen-sk`);
        }, 3000);
    };

    const handleRelease = () => {
        let bodyRequest = {
            subject: detail?.subject,
            receivers: detail?.receivers.map((x) => {
                return x.is_title ? x.officer.nip : x.nip;
            }),

            approvers: detail?.approvers.map((x) => {
                return x.is_title ? x.officer.nip : x.nip;
            }),
            action: 'release',

            comment: 'Release',
            tipe_dokumen: detail?.tipe_dokumen,
            id_course: '',
            extra_attributes: {
                noDokumen: detail.extra_attributes.noDokumen,
                keterangan: detail.extra_attributes.keterangan,
                tipeDokumen: detail.extra_attributes.tipeDokumen,
                jenisDokumen: detail.extra_attributes.jenisDokumen,
                tanggalDokumen: new Date().toISOString(),
            },
        };
        setIsProcessed(true);

        dispatch(
            onReleaseDigiSign(bodyRequest, undefined, 'dokumen-sk', detail.id),
        );

        setTimeout(() => {
            setIsProcessed(false);

            navigation(`/apps/dokumen-sk`);
        }, 3000);
    };

    const handleValidation = () => {
        let pass;
        if (stateDialog.passphrase === '') pass = true;
        else pass = false;
        setError({
            ...error,
            passphrase: pass,
        });
    };

    const handleSkCommentClose = () => {
        setModalComment(false);
        if (comment != '') {
            switch (commentType) {
                case 'Revisi':
                    handleRevision();
                    break;

                case 'Tolak':
                    handleReturn();
                    break;

                case 'Reject':
                    handleReject();
                    break;

                default:
                    break;
            }
        }
    };

    const getAvatarLogs = (user) => {
        if (detail) {
            let idx = detail.approvers.findIndex((x) => x.nama === user);
            if (idx > -1)
                return detail.approvers[idx].avatar_url
                    ? detail.approvers[idx].avatar_url
                    : detail.approvers[idx].composer_avatar;
            else return '';
        } else return '';
    };

    const handleSubmitSign = () => {
        handleValidation();
        if (stateDialog.passphrase !== '') {
            handleSign(stateDialog.passphrase, hasBypassRole && stateDialog.isBypass);
            handleCloseSignDialog();
        }
    };

    const handleCloseSignDialog = () => {
        setStateDialog({
            passphrase: '',
            komentar: '',
            isBypass: true,
        });
        setError({
            passphrase: false,
            komentar: false,
        });
        setOpenDialog(false);
    };

    const renderBreadcrumb = () => {
        return (
            <Breadcrumbs aria-label='breadcrumb'>
                <Typography
                    sx={{
                        cursor: 'pointer',
                        fontWeight: pathname === '/apps/dokumen-sk' ? 'bold' : '500',
                    }}
                    color={'primary.default'}
                    variant='h3'
                    onClick={() => {
                        navigation(`/apps/dokumen-sk`);
                    }}
                >
                    Dokumen Sk
                </Typography>

                {pathname === `/apps/dokumen-sk/tambah-dokumen/${type}` ? (
                    <Typography
                        color={'primary.default'}
                        sx={{ cursor: 'pointer' }}
                        variant='h3'
                        fontWeight={'bold'}
                    >
                        Tambah
                    </Typography>
                ) : pathname === `/apps/dokumen-sk/tambah-dokumen/${type}/${id}` &&
                    id !== undefined ? (
                    <Typography
                        color={'primary.default'}
                        sx={{ cursor: 'pointer' }}
                        variant='h3'
                        fontWeight={'bold'}
                    >
                        Ubah Draft
                    </Typography>
                ) : pathname === '/apps/dokumen-sk/tanda-tangan' ? (
                    <Typography
                        color={'primary.default'}
                        sx={{ cursor: 'pointer' }}
                        variant='h3'
                        fontWeight={'bold'}
                    >
                        Tanda Tangan
                    </Typography>
                ) : id !== undefined && pathname === `/apps/dokumen-sk/detail/${type}/${id}` ? (
                    <Typography
                        color={'primary.default'}
                        sx={{ cursor: 'pointer' }}
                        variant='h3'
                        fontWeight={'bold'}
                    >
                        Detail
                    </Typography>
                ) : null}
            </Breadcrumbs>
        );
    };

    const openPDF = (data) => {
        const iframe = document.querySelector("#iframeSK");
        const wrapper = document.querySelector("#wrapperIframe")
        if (iframe) {
            wrapper.appendChild(iframe);

            iframe.onload = function () {
                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                // Inject custom styles into the iframe
                const style = iframeDoc.createElement("style");
                style.textContent = `
                    #editorModeButtons #editorFreeText,
                    #editorModeButtons #editorInk, 
                    #editorModeButtons #editorStamp {
                        display: none !important; /* Hide specific annotations */
                    }
                `;
                iframeDoc.head.appendChild(style);

                // Open the PDF file in the viewer
                iframe.contentWindow?.PDFViewerApplication.open(data);
            };
        }
    }

    useEffect(() => {
        if (profileMe) {
            const monitoringRole =
                profileMe.roles_coofis.findIndex(
                    (x) => x.state === 'MONITORING_DIGITAL_SIGN',
                ) > -1
                    ? true
                    : false;

            setMonitoringRole(monitoringRole);
        }
    }, [profileMe]);

    // useEffect(() => {
    //     if (id !== undefined && pathname === `/apps/dokumen-sk/detail/${type}/${id}` && detail === null) {
    //         let filterParam = queryParams.get('filter')
    //         if (filterParam) {
    //             dispatch(onChangeFilter(filterParam))
    //         }
    //         dispatch(onGetDetailDigisign(id, monitoringRole ? true : false));
    //         // window.localStorage.clear()
    //     }
    //     setIsProcessed(false);
    // }, [id]);

    useEffect(() => {
        if (
            detail !== null &&
            id !== undefined &&
            pathname === `/apps/dokumen-sk/detail/${type}/${id}`
        ) {
            setUploadedFiles(null);
            dispatch(onDeleteAttachmentDigisign());
            detail?.attachments.map((item) => {
                setUploadedFiles({
                    name: item.name,
                    type: getFileExtension(item.name),
                    size: item.file_size,
                });
            });

            // Filter only "approve" actions
            const filteredData = detail?.logs.filter(
                (item) => item.action === 'approve',
            );

            // Sort by created_at in descending order
            filteredData.sort(
                (a, b) => new Date(b.created_at) - new Date(a.created_at),
            );

            // Get distinct users by their latest "approve" action
            const distinctApproves = {};
            filteredData.forEach((item) => {
                if (!distinctApproves[item.user]) {
                    distinctApproves[item.user] = item;
                }
            });
            setLogs(Object.values(distinctApproves).reverse());
            openPDF(detail.attachments[0].file)

            let temp = detail?.approvers.some((x, index) => index === 1 && x.nip.includes(user.nip))
            setReleaseRole(temp)
        }
    }, [detail]);

    return detail !== null ? (
        <>
            <AppInfoView />

            <Stack
                spacing={2}
                sx={{
                    '& label.Mui-focused': {
                        color: COLORS.primary,
                    },
                    '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                            borderColor: grey[500],
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: COLORS.primary,
                            color: COLORS.primary
                        },
                    },
                }}
            >
                {renderBreadcrumb()}

                <Stack>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={9}>
                            <Stack spacing={4}>
                                {/* Detail Dokumen */}
                                <AppCard sxStyle={{ backgroundColor: 'white !important' }}>
                                    <Stack spacing={2}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Box>
                                                <Tooltip title={'Kembali'} placement='top' arrow>
                                                    <IconButton onClick={() => navigation(-1)}>
                                                        <ArrowBack />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>

                                            <Stack direction='row' spacing={2}>
                                                <ButtonOutlined
                                                    variant='outlined'
                                                    onClick={() => navigation(-1)}
                                                >
                                                    Tutup
                                                </ButtonOutlined>
                                                {filter === 'sk-need-sign' &&
                                                    detail.approvers.length - 1 == detail.sequence && (
                                                        <ButtonContained
                                                            variant='contained'
                                                            onClick={() => {
                                                                // Passphrase already saved (bypass) -> confirmation only, otherwise ask for passphrase
                                                                if (user?.is_bypass) {
                                                                    setModalConfBypass(true)
                                                                } else {
                                                                    setOpenDialog(true)
                                                                }
                                                            }}
                                                            disabled={isProcessed}>
                                                            Proses Tanda Tangan
                                                        </ButtonContained>
                                                    )}
                                                {(filter === 'sk-need-sign' ||
                                                    filter === 'sk-need-approval') && (
                                                        <ButtonContained
                                                            variant='contained'
                                                            sx={tolakButtonSx}
                                                            onClick={() => {
                                                                setModalComment(true);
                                                                setCommentType('Tolak');
                                                            }}
                                                            disabled={isProcessed}
                                                        >
                                                            Tolak
                                                        </ButtonContained>
                                                    )}
                                                {filter === 'completed' && (
                                                    <ButtonContained
                                                        variant='contained'
                                                        onClick={() => {
                                                            setModalComment(true);
                                                            setCommentType('Reject');
                                                        }}
                                                        disabled={isProcessed}
                                                    >
                                                        Batalkan
                                                    </ButtonContained>
                                                )}{' '}
                                                {filter === 'completed' && detail.tipe_dokumen === 'dokumen_sk' && (
                                                    <ButtonContained
                                                        variant='contained'
                                                        onClick={() => {
                                                            setModalComment(true);
                                                            setCommentType('Revisi');
                                                        }}
                                                        disabled={isProcessed}
                                                    >
                                                        Revisi
                                                    </ButtonContained>
                                                )}
                                                {filter === 'sk-need-approval' && (
                                                    <ButtonContained
                                                        variant='contained'
                                                        onClick={() => setModalConfApprove(true)}
                                                        disabled={isProcessed}
                                                    >
                                                        Setujui
                                                    </ButtonContained>
                                                )}
                                                {!detail?.is_release && releaseRole && filter === 'composer' && (
                                                    <ButtonContained
                                                        variant='contained'
                                                        disabled={isProcessed}
                                                        onClick={() => setModalConfRelease(true)}
                                                    >
                                                        Rilis SK
                                                    </ButtonContained>
                                                )}
                                            </Stack>
                                        </Box>

                                        <Divider />

                                        <Stack spacing={5} paddingTop={5}>
                                            <Typography
                                                variant='h1'
                                                color={'primary.default'}
                                                component='div'
                                                textTransform={'capitalize'}
                                            >
                                                {detail?.subject}
                                            </Typography>

                                            <Grid container rowSpacing={4}>
                                                <Grid item xs={5} sm={3}>
                                                    <Typography fontWeight={'bold'}>No Dokumen</Typography>
                                                </Grid>
                                                <Grid item xs={7} sm={9}>
                                                    <Typography>{detail?.extra_attributes?.noDokumen}</Typography>
                                                </Grid>

                                                <Grid item xs={5} sm={3}>
                                                    <Typography fontWeight={'bold'}>Operator</Typography>
                                                </Grid>
                                                <Grid container item xs={7} sm={9}>
                                                    <Grid item xs={6}>
                                                        <Stack direction='row' alignItems={'center'} spacing={4}>
                                                            <Avatar
                                                                src={
                                                                    detail?.composer?.composer_avatar ||
                                                                    detail?.composer?.avatar_url
                                                                }
                                                                sx={{
                                                                    width: { xs: '40px', md: '50px' },
                                                                    height: { xs: '40px', md: '50px' },
                                                                }}
                                                            ></Avatar>

                                                            <Stack spacing={1}>
                                                                <Typography
                                                                    variant='h3'
                                                                    fontSize={{ xs: 12, md: 18 }}
                                                                    fontWeight={'bold'}
                                                                >
                                                                    {detail?.composer?.is_title
                                                                        ? detail?.composer?.officer?.nama
                                                                        : detail?.composer?.nama}
                                                                </Typography>
                                                                <Typography
                                                                    fontSize={{ xs: 12, md: 18 }}
                                                                    sx={{ color: (theme) => theme.palette.text.disabled }}
                                                                >
                                                                    {detail?.composer?.is_title
                                                                        ? detail?.composer?.display_title
                                                                        : null}
                                                                </Typography>
                                                            </Stack>
                                                        </Stack>
                                                    </Grid>
                                                </Grid>

                                                {/* <Grid item xs={3}>
                                        <Typography fontWeight={'bold'}>Penerima Sertifikat</Typography>
                                    </Grid>
                                    <Grid container item xs={9}>
                                        {
                                            detail?.tembusans?.map((item, index) => (
                                                <Grid item xs={6} key={index}>
                                                    <Stack direction='row' alignItems={'center'} spacing={4}>
                                                        <Avatar {...stringAvatar(item.is_title ? item.officer.nama : item.nama)} src={item?.avatar_url} sx={{ width: '50px', height: '50px' }}>
                                                        </Avatar>

                                                        <Stack spacing={1}>
                                                            <Typography variant='h3' fontWeight={'bold'}>{item?.is_title ? item?.officer?.nama : item?.nama}</Typography>
                                                            <Typography sx={{ color: (theme) => theme.palette.text.disabled }}>{item?.is_title ? item?.display_title : null}</Typography>
                                                        </Stack>
                                                    </Stack>
                                                </Grid>
                                            ))
                                        }
                                    </Grid> */}

                                                <Grid item xs={5} sm={3}>
                                                    <Typography fontWeight={'bold'}>
                                                        Tanggal Dokumen Dibuat
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={7} sm={9}>
                                                    <Typography>
                                                        {moment(detail?.extra_attributes?.tanggalDokumen).format(
                                                            'DD MMMM YYYY',
                                                        )}
                                                    </Typography>
                                                </Grid>

                                                {type === 'sdmao' && (
                                                    <>
                                                        <Grid item xs={5} sm={3}>
                                                            <Typography fontWeight={'bold'}>
                                                                Jenis Dokumen
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={7} sm={9}>
                                                            <Typography>
                                                                {detail?.extra_attributes?.jenisDokumen}
                                                            </Typography>
                                                        </Grid>
                                                    </>
                                                )}

                                                <Grid item xs={5} sm={3}>
                                                    <Typography fontWeight={'bold'}>Keterangan</Typography>
                                                </Grid>
                                                <Grid item xs={7} sm={9}>
                                                    <Typography
                                                        sx={{ color: (theme) => theme.palette.text.disabled }}
                                                    >
                                                        {detail?.extra_attributes?.keterangan === ''
                                                            ? '-'
                                                            : detail?.extra_attributes?.keterangan}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Stack>
                                    </Stack>
                                </AppCard>

                                {/* Penerima dan Tembusan */}
                                <Stack>
                                    <Grid container spacing={4}>
                                        <Grid item xs={12} md={6}>
                                            <AppCard sxStyle={{ backgroundColor: 'white !important', height: 200 }} contentStyle={{ padding: '0 !important' }}>
                                                <Stack spacing={4} height={'100%'} paddingY={'16px'}>
                                                    <Stack paddingX={'24px'}>
                                                        <Typography variant='h3' fontWeight={'bold'} color={'primary.default'} component='div' textTransform={'capitalize'}>
                                                            Penerima
                                                        </Typography>
                                                    </Stack>

                                                    <Stack height={'100%'} position={'relative'}>
                                                        {detail?.receivers.length > 0 ? (
                                                            <Stack position={'absolute'} width={'100%'} height={'100%'}>
                                                                <AppScrollbar>
                                                                    <Stack paddingX={'24px'}>
                                                                        <Grid container spacing={4}>
                                                                            {
                                                                                detail?.receivers?.map((item, index) => (
                                                                                    <Grid item xs={12} md={12} key={index}>
                                                                                        <Stack spacing={2}>
                                                                                            <Stack spacing={2}>
                                                                                                <Stack direction='row' alignItems={'center'} spacing={2}>
                                                                                                    <Avatar src={item?.avatar_url || item?.composer_avatar} sx={{ width: { xs: '20px', md: '30px' }, height: { xs: '20px', md: '30px' } }}>
                                                                                                        <Person sx={{ fontSize: '24px' }} />
                                                                                                    </Avatar>

                                                                                                    <Stack spacing={1}>
                                                                                                        {item.is_title ? (
                                                                                                            <>
                                                                                                                <Typography variant='h3' fontSize={{ xs: 12, md: 14 }} fontWeight={'bold'}>{item?.is_title ? item?.display_title : '-'}</Typography>
                                                                                                                <Typography fontSize={{ xs: 11, md: 14 }} sx={{ color: (theme) => theme.palette.text.disabled }}>{item?.is_title ? item?.officer?.nama : item?.nama}</Typography>
                                                                                                            </>
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                <Typography variant='h3' fontSize={{ xs: 12, md: 14 }} fontWeight={'bold'}>{item?.is_title ? item?.display_title : item?.nama}</Typography>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </Stack>
                                                                                                </Stack>
                                                                                            </Stack>
                                                                                        </Stack>
                                                                                    </Grid>
                                                                                ))
                                                                            }
                                                                        </Grid>
                                                                    </Stack>
                                                                </AppScrollbar>
                                                            </Stack>
                                                        ) : (
                                                            <Stack height={1} alignItems={'center'} justifyContent={'center'}>
                                                                <Typography>Tidak ada data</Typography>
                                                            </Stack>
                                                        )}
                                                    </Stack>
                                                </Stack>
                                            </AppCard>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <AppCard sxStyle={{ backgroundColor: 'white !important', height: 200 }} contentStyle={{ padding: '0 !important' }}>
                                                <Stack spacing={4} height={'100%'} paddingY={'16px'}>
                                                    <Stack paddingX={'24px'}>
                                                        <Typography variant='h3' fontWeight={'bold'} color={'primary.default'} component='div' textTransform={'capitalize'}>
                                                            Tembusan
                                                        </Typography>
                                                    </Stack>

                                                    <Stack height={'100%'} position={'relative'}>
                                                        {detail?.tembusans !== null && (Array.isArray(detail?.tembusans) && detail?.tembusans.length) > 0 ? (
                                                            <Stack position={'absolute'} width={'100%'} height={'100%'}>
                                                                <AppScrollbar>
                                                                    <Stack paddingX={'24px'}>
                                                                        <Grid container spacing={4}>
                                                                            {
                                                                                detail?.tembusans?.map((item, index) => (
                                                                                    <Grid item xs={12} md={12} key={index}>
                                                                                        <Stack spacing={2}>
                                                                                            <Stack spacing={2}>
                                                                                                <Stack direction='row' alignItems={'center'} spacing={2}>
                                                                                                    <Avatar src={item?.avatar_url || item?.composer_avatar} sx={{ width: { xs: '20px', md: '30px' }, height: { xs: '20px', md: '30px' } }}>
                                                                                                        <Person sx={{ fontSize: '24px' }} />
                                                                                                    </Avatar>

                                                                                                    <Stack spacing={1}>
                                                                                                        {item.is_title ? (
                                                                                                            <>
                                                                                                                <Typography variant='h3' fontSize={{ xs: 12, md: 14 }} fontWeight={'bold'}>{item?.is_title ? item?.display_title : '-'}</Typography>
                                                                                                                <Typography fontSize={{ xs: 11, md: 14 }} sx={{ color: (theme) => theme.palette.text.disabled }}>{item?.is_title ? item?.officer?.nama : item?.nama}</Typography>
                                                                                                            </>
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                <Typography variant='h3' fontSize={{ xs: 12, md: 14 }} fontWeight={'bold'}>{item?.is_title ? item?.display_title : item?.nama}</Typography>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </Stack>
                                                                                                </Stack>
                                                                                            </Stack>
                                                                                        </Stack>
                                                                                    </Grid >
                                                                                ))
                                                                            }
                                                                        </Grid>
                                                                    </Stack>
                                                                </AppScrollbar>
                                                            </Stack>
                                                        ) : (
                                                            <Stack height={1} alignItems={'center'} justifyContent={'center'}>
                                                                <Typography>Tidak ada data</Typography>
                                                            </Stack>
                                                        )}
                                                    </Stack>
                                                </Stack>
                                            </AppCard>
                                        </Grid>
                                    </Grid>
                                </Stack>

                                {/* Dokumen */}
                                <AppCard sxStyle={{ backgroundColor: 'white !important' }}>
                                    <Stack spacing={4}>
                                        <Typography variant='h3' fontWeight={'bold'} color={'primary.default'} component='div' textTransform={'capitalize'}>
                                            Dokumen
                                        </Typography>

                                        <Stack id='wrapperIframe' height={'100vh'}>
                                            <iframe src='/assets/latest-pdfjs-dist/web/viewer.html' id='iframeSK' style={{ height: '100%', border: 0 }} />
                                        </Stack>
                                    </Stack>
                                </AppCard>
                            </Stack>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Stack spacing={4} height={'100%'}>
                                {/* Penanggung Jawab */}
                                <Stack height={{ xs: '400px', md: '100%' }}>
                                    <AppCard sxStyle={{ backgroundColor: 'white !important', height: '100%' }} contentStyle={{ padding: '0 !important' }}>
                                        <Stack spacing={4} height={'100%'} paddingY={'16px'}>
                                            <Stack paddingX={'24px'}>
                                                <Typography variant='h3' fontWeight={'bold'} color={'primary.default'} component='div' textTransform={'capitalize'}>
                                                    Penanggung Jawab
                                                </Typography>
                                            </Stack>

                                            <Stack height={'100%'} position={'relative'}>
                                                <Stack position={'absolute'} width={'100%'} height={'100%'}>
                                                    <AppScrollbar>
                                                        <Stack paddingX={'24px'}>
                                                            <Grid container spacing={4}>
                                                                {
                                                                    detail?.approvers?.map((item, index) => (
                                                                        (index !== 0) ? (
                                                                            <>
                                                                                <Grid item xs={12} md={12} key={index}>
                                                                                    <Stack spacing={4}>
                                                                                        <Stack spacing={2}>
                                                                                            <Stack direction='row' alignItems={'center'} spacing={4}>
                                                                                                <Avatar src={item?.avatar_url || item?.composer_avatar} sx={{ width: { xs: '30px', md: '40px' }, height: { xs: '30x', md: '40px' } }}>
                                                                                                    <Person sx={{ fontSize: '28px' }} />
                                                                                                </Avatar>

                                                                                                <Stack spacing={1}>
                                                                                                    {detail.approvers.length == index + 1 ? (
                                                                                                        <Typography variant='h6'>
                                                                                                            Penandatangan
                                                                                                        </Typography>
                                                                                                    ) : (
                                                                                                        <Typography variant='h6'>
                                                                                                            Persetujuan {index}
                                                                                                        </Typography>
                                                                                                    )}

                                                                                                    {item.is_title ? (
                                                                                                        <>
                                                                                                            <Typography variant='h3' fontSize={{ xs: 12, md: 16 }} fontWeight={'bold'}>{item?.is_title ? item?.display_title : '-'}</Typography>
                                                                                                            <Typography fontSize={{ xs: 11, md: 14 }} sx={{ color: (theme) => theme.palette.text.disabled }}>{item?.is_title ? item?.officer?.nama : item?.nama}</Typography>
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <Typography variant='h3' fontSize={{ xs: 12, md: 16 }} fontWeight={'bold'}>{item?.is_title ? item?.display_title : item?.nama}</Typography>
                                                                                                        </>
                                                                                                    )}

                                                                                                    {logs && logs[index - 1] !== undefined && detail?.sequence > index && (
                                                                                                        <Typography variant='h6' component={'span'} color={'GrayText'}>
                                                                                                            {
                                                                                                                detail.approvers.length == index + 1
                                                                                                                    ? 'Ditandatangani'
                                                                                                                    : 'Disetujui'
                                                                                                            }
                                                                                                            :{' '}
                                                                                                            {moment(
                                                                                                                logs[index - 1].created_at,
                                                                                                            ).format('DD MMMM YYYY || HH:mm')}
                                                                                                        </Typography>
                                                                                                    )}

                                                                                                    <Stack direction={'row'} alignItems={'center'} gap={1}>
                                                                                                        {approveCheck(detail.approvers.length, detail?.sequence, index,)}
                                                                                                    </Stack>
                                                                                                </Stack>
                                                                                            </Stack>
                                                                                        </Stack>

                                                                                        <Divider orientation='horizontal' flexItem />
                                                                                    </Stack>

                                                                                </Grid>
                                                                            </>
                                                                        ) : null
                                                                    ))
                                                                }
                                                            </Grid>
                                                        </Stack>
                                                    </AppScrollbar>
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    </AppCard>
                                </Stack>

                                {/* Riwayat Aktifitas */}
                                <Stack height={{ xs: '400px', md: '100%' }}>
                                    <AppCard sxStyle={{ backgroundColor: 'white !important', height: '100%' }} contentStyle={{ padding: '0 !important' }}>
                                        <Stack spacing={4} height={'100%'} paddingY={'16px'}>
                                            <Stack paddingX={'24px'}>
                                                <Typography variant='h3' fontWeight={'bold'} color={'primary.default'} component='div' textTransform={'capitalize'}>
                                                    Riwayat Aktivitas
                                                </Typography>
                                            </Stack>

                                            <Stack height={'100%'} position={'relative'}>
                                                <Stack position={'absolute'} width={'100%'} height={'100%'}>
                                                    <AppScrollbar>
                                                        <Stack paddingX={'24px'}>
                                                            <LogHistory data={detail?.logs} />
                                                        </Stack>
                                                    </AppScrollbar>
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    </AppCard>
                                </Stack>
                            </Stack>
                        </Grid>
                    </Grid>
                </Stack>
            </Stack>

            <ModalSkComment
                open={modalComment}
                comment={comment}
                setComment={setComment}
                handleClose={handleSkCommentClose}
                type={commentType}
            />

            <DialogKonfirmasi
                open={modalConfBypass}
                handleClose={(status = 0) => {
                    if (status === 1) {
                        handleSign()
                    }
                    setModalConfBypass(false)
                }}
                labelPesan={'Tanda Tangan Dokumen'}
                isiPesan={`Apakah anda yakin akan menandatangani dokumen ini?`}
                labelTombol='Ya'
            />

            <DialogKonfirmasi
                open={modalConfApprove}
                handleClose={(status = 0) => {
                    if (status === 1) {
                        handleApprove();
                    }
                    setModalConfApprove(false)
                }}
                labelPesan={'Approve SK'}
                isiPesan={`Apakah anda yakin akan menyetujui dokumen sk ini?`}
                labelTombol='Ya'
            />

            <DialogKonfirmasi
                open={modalConfReject}
                handleClose={(status = 0) => {
                    if (status === 1) {
                        handleReject();
                    }
                    setModalConfReject(false)
                }}
                labelPesan={'Reject SK'}
                isiPesan={`Apakah anda yakin akan membatalkan dokumen sk ini?`}
                labelTombol='Ya'
            />

            <DialogKonfirmasi
                open={modalConfRelease}
                handleClose={(status = 0) => {
                    if (status === 1) {
                        handleRelease();
                    }
                    setModalConfRelease(false)
                }}
                labelPesan={'Rilis SK'}
                isiPesan={`Apakah anda yakin akan merilis dokumen sk ini?`}
                labelTombol='Ya'
            />

            <DialogKonfirmasi
                open={modalConfRevision}
                handleClose={(status = 0) => {
                    if (status === 1) {
                        handleRevision();
                    }
                    setModalConfRevision(false)
                }}
                labelPesan={'Revisi SK'}
                isiPesan={`Apakah anda yakin akan merevisi dokumen sk ini?`}
                labelTombol='Ya'
            />

            <DialogKonfirmasi
                open={modalConfReturn}
                handleClose={(status = 0) => {
                    if (status === 1) {
                        handleReturn();
                    }
                    setModalConfReturn(false)
                }}
                labelPesan={'Return SK'}
                isiPesan={`Apakah anda yakin akan mengembalikan dokumen sk ini ke draft?`}
                labelTombol='Ya'
            />

            <DialogSignDetail
                error={error}
                open={openDialog}
                state={stateDialog}
                title={'Form Tanda Tangan'}
                handleSubmit={handleSubmitSign}
                onChangeState={handleChangeDialog}
                handleClose={handleCloseSignDialog}
            />

            {
                index >= 0 ? (
                    <MediaViewer
                        index={index}
                        medias={{
                            url: detail.attachments[index].file,
                            mime_type: uploadedFiles.type,
                            name: uploadedFiles.name,
                            size: getFileSize(uploadedFiles.size),
                        }}
                        onClose={onCloseShowAttachment}
                    />
                ) : null
            }
        </>
    ) : null;
};

Detail.propTypes = {
    setRefresh: PropTypes.func,
};

export default Detail;
